import clsx from "clsx";
import Image from "next/image";
import type { ComponentProps } from "react";
import type { ProductDetails } from "@/lib/centra/formatters";
import styles from "./ProductFeatures.module.css";

export interface ProductFeaturesProps extends ComponentProps<"div"> {
  features: ProductDetails["features"];
}

export const ProductFeatures = ({
  features,
  className,
  ...rest
}: ProductFeaturesProps) => {
  return (
    <div className={clsx(styles.root, className)} {...rest}>
      {(features || [])
        .sort((a, b) => b.label.localeCompare(a.label))
        .map((feature, i) => (
          <div key={i} className={styles.feature}>
            <div className={styles.image}>
              <Image fill alt="" src={feature.icon} />
            </div>
            <span>{feature.label}</span>
          </div>
        ))}
    </div>
  );
};
